<mat-card>
  <mat-card-title class="hideForPrint">
    <div class="flex justify-between">
      <p>Reports</p>
      <div class="text-sm flex items-center gap-4">
        <button mat-flat-button color="accent" (click)="closeReport()">Close</button>
      </div>
    </div>
  </mat-card-title>

  <!-- KAM Records -->
  <ng-container *ngIf="showKamReports()">
    <app-kam-reports [projectId]="reportParams.projectId"></app-kam-reports>
  </ng-container>

  <ng-container *ngIf="!showKamReports()">
    <app-reports-review [reportParams]="reportParams"></app-reports-review>
  </ng-container>


</mat-card>
